module.exports = __webpack_public_path__ + "static/img/nhis-cs.d5068bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/nhis-cs.jpg
// module id = 9v7R
// module chunks = 0